<script setup lang="ts">
const props = defineProps<{
  context: {
    value: boolean
    node: { input: (v: boolean) => void }
  } & Record<string, any>
}>()

const handleInput = (value: boolean) => {
  props.context.node.input(value)
}
</script>

<template>
  <n-switch
    :value="context.value"
    @update:value="e => handleInput(e)"
  />
</template>
